import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 
import { HomeComponent } from './components/home/home.component';
import { SimulatorComponent } from './components/simulator/simulator.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: ':reload', component: HomeComponent },
    { path: 'simulator', component: SimulatorComponent },
    { path: 'simulator/:algorithm/:noNodes/:simSpeed/:simTime/:nodeRadius/:msgFreq/:numMsgCopies', component: SimulatorComponent }
]; 

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }